import { IPlugin } from '../types';

enum CLASSES {
  CURRENT = 'current',
  SLIDE = 'slide'
}

export default class Slider {
  private root: HTMLDivElement;
  constructor() {
    const root = document.getElementById('slider') as HTMLDivElement;
    this.root = root;

    document.documentElement.classList.add('slider');
  }
  registerPlugins(...plugins: IPlugin[]) {
    plugins.forEach((Plugin) => new Plugin(this));
  }

  getRoot() {
    return this.root;
  }

  getItems() {
    return Array.from(this.root.querySelectorAll('section'));
  }

  getCurrentSlide() {
    const current = this.root.querySelector('.current') as HTMLElement;
    return current;
  }

  getCurrentSlideIndex() {
    return this.getItems().indexOf(this.getCurrentSlide());
  }

  slideTo(idx: number) {
    const current = this.getCurrentSlide();
    if (current) {
      current.classList.remove(CLASSES.CURRENT);
    }
    const item = this.getItems()[idx];
    if (item) {
      item.classList.add(CLASSES.CURRENT);
    }

    const detail = { index: idx };
    const event = new CustomEvent('slide', { bubbles: true, detail });
    this.root.dispatchEvent(event);
  }

  slidePrevious() {
    const currentIdx = this.getCurrentSlideIndex();
    // const items = this.getItems();
    // const previousIdx = (items.length + currentIdx - 1) % items.length;
    if (currentIdx) {
      this.slideTo(currentIdx - 1);
    }
  }

  slideNext() {
    const currentIdx = this.getCurrentSlideIndex();
    // const nextIdx = (currentIdx + 1) % this.getItems().length;
    if (currentIdx < this.getItems().length - 1) {
      this.slideTo(currentIdx + 1);
    }
  }

  isLastSlide() {
    return this.getItems()[this.getItems().length - 1] === this.getCurrentSlide();
  }

  displayAllItems() {
    this.getItems().forEach((item) => {
      item.classList.remove(CLASSES.CURRENT);
      item.classList.add(CLASSES.SLIDE);
    });
  }
}
